import { Thermostat } from '@energybox/react-ui-library/dist/types';
import { isDefined } from '@energybox/react-ui-library/dist/utils';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  subscribeToDeviceReadings,
  subscribeToDeviceStatus,
  unsubscribeFromDeviceReadings,
  unsubscribeFromDeviceStatus,
} from '../../actions/streamApi';
import { ApplicationState } from '../../reducers';
import { DeviceStatusById } from '../../reducers/deviceStatus';

const useSubscribeToStreamEntities = (thermostat: Thermostat) => {
  const dispatch = useDispatch();
  const vendor = thermostat?.vendor;
  const uuid = thermostat?.uuid;
  const id = thermostat?.id;

  useEffect(() => {
    // The thermostat is usually undefined on the first render, so the effect has
    // to re-run once it loads or the card never subscribes at all.
    if (!isDefined(vendor) || !isDefined(uuid)) {
      return undefined;
    }

    dispatch(subscribeToDeviceReadings(vendor, uuid, id));
    dispatch(subscribeToDeviceStatus(vendor, uuid, id));

    return () => {
      dispatch(unsubscribeFromDeviceReadings(vendor, uuid, id));
      dispatch(unsubscribeFromDeviceStatus(vendor, uuid, id));
    };
  }, [dispatch, vendor, uuid, id]);

  const subscribedThermostat = useSelector(
    ({ subscribedThermostats }: ApplicationState) => {
      if (thermostat) {
        return subscribedThermostats.byId[thermostat.id];
      }
      return undefined;
    }
  );

  const deviceStatusById: DeviceStatusById = useSelector<
    ApplicationState,
    DeviceStatusById
  >(state => state.deviceStatusById);

  return { subscribedThermostat, deviceStatusById };
};
export default useSubscribeToStreamEntities;
